import { i18N } from "../../../helper";
class CONSTANTS {
    static template() {
        return `<div class="input__section -rounding">
			<div class="input__divider">
				<span class="input__divider__label">${i18N().decimals}</span>
				<div class="input__divider__line"></div>
			</div>
			<div class="input__group">
				<select name="rounding_type" class="select__medium">
					<option value="">${i18N().rounding_none}</option>
					<option value="roundup">${i18N().rounding_up}</option>
					<option value="rounddown">${i18N().rounding_down}</option>
				</select>
				<div class="input__controlgroup -rounding">
					<span class="input__control__prepend">,</span>
					<input type="number" max="99" min="0" placeholder="" name="rounding" value="00">
				</div>					
			</div>
			<div class="roundingexample">
				<span class="roundingexample__label">${i18N().rounding_example}</span>
				<span class="roundingexample__original" data-example-price>145.85</span>
				<span class="roundingexample__sep">&rarr;</span>
				<span class="roundingexample__rounded" data-example-new>145.85</span>
			</div>
		</div>`;
    }
}
export default class RoundingSection {
    constructor() {
        this.state = false;
        this.setElement();
        this.attachEvents();
        this.refreshRoundingState();
    }
    setElement() {
        let element = document.createElement('div');
        element.innerHTML = CONSTANTS.template();
        this.el = element.querySelector('.input__section');
    }
    getElement() {
        return this.el;
    }
    getTypeElement() {
        return this.el.querySelector('[name=rounding_type]');
    }
    getRoundingElement() {
        return this.el.querySelector('[name=rounding]');
    }
    getExampleElement() {
        return this.el.querySelector('.roundingexample');
    }
    attachEvents() {
        this.getTypeElement().addEventListener('change', () => { this.refreshRoundingState(); });
        this.getTypeElement().addEventListener('change', () => { this.getRoundedValue(); });
        this.getRoundingElement().addEventListener('change', () => { this.getRoundedValue(); });
    }
    getValue() {
        let type = this.getTypeElement().value;
        let decimals = this.getRoundingElement().value;
        if (type === '') {
            this.state = false;
        }
        return {
            active: this.state,
            type: type,
            decimals: decimals,
        };
    }
    enable() {
        this.state = true;
    }
    disable() {
        this.state = false;
        this.getTypeElement().value = '';
        this.refreshRoundingState();
    }
    show() {
        this.getElement().style.display = 'block';
        this.enable();
    }
    hide() {
        this.getElement().style.display = 'none';
        this.disable();
    }
    getRoundedValue() {
        jQuery.ajax({
            url: ajaxurl,
            data: {
                action: 'acp-rounding',
                price: this.getElement().querySelector('[data-example-price]').innerHTML,
                decimals: this.getRoundingElement().value,
                type: this.getTypeElement().value
            }
        }).done((data) => {
            this.getElement().querySelector('[data-example-new]').innerHTML = data;
        });
    }
    refreshRoundingState() {
        let rounding_type = this.getTypeElement();
        let example = this.getExampleElement();
        let input = this.getElement().querySelector('.input__controlgroup.-rounding');
        if (rounding_type.value) {
            input.style.visibility = 'visible';
            example.style.display = 'block';
            this.state = true;
        }
        else {
            input.style.visibility = 'hidden';
            example.style.display = 'none';
        }
    }
}
